module.exports = __webpack_public_path__ + "img/store-search.53d0efbc.png";